import React, { useEffect, useState } from "react";
import { usePermissions } from "../../common/PermissionContext";
import { Link, useLocation } from "react-router-dom";
import * as func from "../../common/manipurCommon/FunctionCalls";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import ImageWithBasePath from "../../../core/data/img/ImageWithBasePath";
import { Button, Modal, ModalBody, ModalHeader, ModalTitle } from "react-bootstrap";

const ActiveAthlete = () => {

    const [athleteList, setAthleteList] = useState<any[]>([]);
    const [info, setInfo] = useState<any[]>([]);
    const [profileInfo, setProfileInfo] = useState<any[]>([]);
    const [physiologicalInfo, setPhysiologicalInfo] = useState<any[]>([]);
    const [medicalBasicInfo, setMedicalBasicInfo] = useState<any[]>([]);
    const [medicalConditionInfo, setMedicalConditionInfo] = useState<any[]>([]);
    const [currentMedicationInfo, setCurrentMedicationInfo] = useState<any[]>([]);
    const [allergiesInfo, setAllergiesInfo] = useState<any[]>([]);
    const [injuryInfo, setInjuryInfo] = useState<any[]>([]);
    const [surgeryInfo, setSurgeryInfo] = useState<any[]>([]);
    const [searchInput, setSearchInput] = useState("");
    const [openModal, setOpenModal] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    const { permissionsMap } = usePermissions();
    const location = useLocation();

    const currentPath = location.pathname;
    const currentPermissions = permissionsMap[currentPath] || [];

    useEffect(() => {
        async function fetchAthleteList() {
            setIsLoading(true);
            const athleteResponse = await func.listAllActiveAthletes();
            setAthleteList(Array.isArray(athleteResponse) ? athleteResponse : [])
            setIsLoading(false);
        }
        fetchAthleteList();
    }, [])

    const filteredData = athleteList.filter((datas) => {
        const values = Object.values(datas).map((value) =>
            value !== null && value !== undefined ? value.toString().toLowerCase() : '');
        return values.some((value) => value.includes(searchInput.toLowerCase()));
    });

    const formatDate = (date) => {
        const dateObj = new Date(date);
        const day = String(dateObj.getDate()).padStart(2, '0');
        const month = String(dateObj.getMonth() + 1).padStart(2, '0');
        const year = dateObj.getFullYear();
        return `${day}-${month}-${year}`;
    };

    const slNoRender = (rowData, column) => {
        return column.rowIndex + 1;
    };

    const athleteNameRender = (rowData) => {
        return <span>{rowData.athleteName}</span>
    };

    const viewDetails = (rowData) => {
        return (
            <Link to="#" onClick={() => fetchDetails(rowData)}>
                Details
            </Link>
        );
    };

    async function fetchDetails(athlete: { userId: string; }) {
        try {
            const athltResponse = await func.athleteInfo(athlete.userId);
            // Handle EMPTY response
            if (!athltResponse || Object.keys(athltResponse).length === 0) {
                // Reset all states safely
                setProfileInfo({});
                setMedicalBasicInfo({});
                setMedicalConditionInfo([]);
                setCurrentMedicationInfo([]);
                setAllergiesInfo([]);
                setInjuryInfo([]);
                setSurgeryInfo([]);
                setPhysiologicalInfo([]);

                return;
            }
            setInfo(athltResponse)
            setProfileInfo(athltResponse?.athleteProfile || {})
            setMedicalBasicInfo(athltResponse?.medicalHistory?.medicalBasicRecord || {})
            setMedicalConditionInfo(athltResponse?.medicalHistory?.medicalConditionRecord || [])
            setCurrentMedicationInfo(athltResponse?.medicalHistory?.athleteCurrentMedicationRecord || [])
            setAllergiesInfo(athltResponse?.medicalHistory?.athleteAllergiesRecord || [])
            setInjuryInfo(athltResponse?.injuryHistory || [])
            setSurgeryInfo(athltResponse?.surgeryHistory || [])
            setPhysiologicalInfo(athltResponse?.physiologicalHistory || [])
            setOpenModal(true)
        }
        catch (error) {
            setProfileInfo({});
            setMedicalBasicInfo({});
            setMedicalConditionInfo([]);
            setCurrentMedicationInfo([]);
            setAllergiesInfo([]);
            setInjuryInfo([]);
            setSurgeryInfo([]);
            setPhysiologicalInfo([]);
        }
    }

    return (
        <>
            {isLoading && (
                <div id="global-loader">
                    <div className="loader-img">
                        <ImageWithBasePath src="assets/img/loader.png" className="img-fluid" alt="Global" />
                    </div>
                </div>
            )}
            <div className="content container" style={{ maxWidth: "1380px", paddingTop: "10px" }}>
                <div className="row">
                    <div className="sortby-section">
                        <div className="sorting-info">
                            <div className="row align-items-center">
                                <div className="col d-flex justify-content-between">
                                    <h4>Athletes</h4>
                                </div>
                                <div className="col-lg-12 col-sm-12 text-end dataTables_filter">
                                    <label>
                                        <input
                                            type="text"
                                            value={searchInput}
                                            onChange={(e) => setSearchInput(e.target.value)}
                                            style={{ height: "40px" }}
                                            placeholder="Search"
                                            className="form-control"
                                        />
                                    </label>
                                </div>
                            </div>
                            <div className="tab-content">
                                <div
                                    className="tab-pane fade show active"
                                    id="nav-Recent"
                                    role="tabpanel"
                                    aria-labelledby="nav-Recent-tab"
                                    tabIndex={0}
                                >
                                    <div className="table-responsive table-datatble">
                                        <DataTable
                                            className="table datatable"
                                            value={filteredData}
                                            paginator
                                            rows={10}
                                            rowsPerPageOptions={[10, 25, 50, 100]}
                                            // currentPageReportTemplate="{first}- {last} of {totalRecords} entries"
                                            pageLinkSize={3}
                                        >
                                            <Column
                                                sortable
                                                headerClassName="text-uppercase"
                                                field="slNo"
                                                body={slNoRender}
                                                header="Sl &nbsp; No"
                                            ></Column>
                                            <Column
                                                sortable
                                                headerClassName="text-uppercase"
                                                field="firstName"
                                                header="Athlete Name"
                                                body={athleteNameRender}
                                                className="table-inset-btn"
                                            ></Column>
                                            {currentPermissions.includes("view") ?
                                                <Column
                                                    className="text-link"
                                                    body={viewDetails}
                                                ></Column>
                                                : null
                                            }
                                        </DataTable>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <Modal
                show={openModal}
                centered
                size="xl">
                <ModalHeader>
                    <ModalTitle>
                        <h4 className="mb-0 upper-case">Athlete Details</h4>
                    </ModalTitle>
                    <Button
                        variant=""
                        className="btn-close"
                        onClick={() => setOpenModal(false)}
                    ></Button>
                </ModalHeader>
                <ModalBody>
                    <div className="card court-information">
                        <div className="card dashboard-card court-information">
                            <div className="card-header">
                                <h4>Basic Details</h4>
                            </div>
                            <div className="appointment-info">
                                <ul className="appointmentset">
                                    <li>
                                        <h6>Name</h6>
                                        <p>{profileInfo.athleteName}</p>
                                    </li>
                                    <li>
                                        <h6>Email</h6>
                                        <p>{profileInfo.userEmail}</p>
                                    </li>
                                    <li>
                                        <h6>Phone</h6>
                                        <p>{profileInfo.userPhone}</p>
                                    </li>
                                    <li>
                                        <h6>Role</h6>
                                        <p>{profileInfo.roleName}</p>
                                    </li>
                                    <li>
                                        <h6>Sport</h6>
                                        <p>{profileInfo.sportsName}</p>
                                    </li>
                                    <li>
                                        <h6>Onboard Status</h6>
                                        <p>{profileInfo.athleteOnboardStatusName}</p>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div className="card dashboard-card court-information">
                            <div className="card-header">
                                <h4>Medical History</h4>
                            </div>
                            <div className="appointment-info appoin-border double-row">
                                <div className="card-header">
                                    <h5>Basic Record</h5>
                                </div>
                                <ul className="appointmentset">
                                    <li>
                                        <h6>Blood Group</h6>
                                        <p>{medicalBasicInfo.bloodGroup}</p>
                                    </li>
                                    <li>
                                        <h6>Tobacco</h6>
                                        <p>{medicalBasicInfo.tobacco}</p>
                                    </li>
                                    <li>
                                        <h6>Alcohol</h6>
                                        <p>{medicalBasicInfo.alcohal}</p>
                                    </li>
                                    <li>
                                        <h6>Medical Condition</h6>
                                        <p>{medicalBasicInfo.medicalCondition}</p>
                                    </li>
                                    <li>
                                        <h6>Medication Category</h6>
                                        <p>{medicalBasicInfo.medicationCategory}</p>
                                    </li>
                                    <li>
                                        <h6>Current Medication</h6>
                                        <p>{medicalBasicInfo.currentMedication}</p>
                                    </li>
                                    <li>
                                        <h6>Allergies</h6>
                                        <p>{medicalBasicInfo.allergyName}</p>
                                    </li>
                                    <li>
                                        <h6>Family Medical History</h6>
                                        <p>{medicalBasicInfo.relevantFamilyMedicalHistory}</p>
                                    </li>
                                </ul>
                            </div>
                            <div className="appointment-info appoin-border double-row">
                                <div className="card-header">
                                    <h5>Medical Condition Records</h5>
                                </div>
                                <ul className="appointmentset">
                                    {medicalConditionInfo.map((item, index) => (
                                        <li key={index}>
                                            <h6>Medical Condition{index + 1}</h6>
                                            <p>{item.medicalCondition}</p>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                            <div className="appointment-info appoin-border double-row">
                                <div className="card-header">
                                    <h5>Current Medication Records</h5>
                                </div>
                                <ul className="appointmentset">
                                    {currentMedicationInfo.map((item, index) => (
                                        <li key={index}>
                                            <h6>Medication Category{index + 1}</h6>
                                            <p>{item.medicationCategory}</p>
                                            <h6>Current Medication{index + 1}</h6>
                                            <p>{item.currentMedication}</p>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                            <div className="appointment-info appoin-border double-row">
                                <div className="card-header">
                                    <h5>Allergies Records</h5>
                                </div>
                                <ul className="appointmentset">
                                    {allergiesInfo.map((item, index) => (
                                        <li key={index}>
                                            <h6>Allergy{index + 1}</h6>
                                            <p>{item.allergyName}</p>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        </div>
                        <div className="card dashboard-card court-information">
                            <div className="card-header">
                                <h4>Injury History</h4>
                            </div>
                            <ul className="appointmentset">
                                <div className="table-responsive table-datatble">
                                    <table className="table datatable">
                                        <thead>
                                            <tr>
                                                <th>Date of Injury</th>
                                                <th>Diagnosis</th>
                                                <th>Severity</th>
                                                <th>Region</th>
                                                <th>Mechanism</th>
                                                <th>Management</th>
                                                <th>Return Date</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {injuryInfo.map(injury => (
                                                <tr key={injury.injuryProfileId}>
                                                    <td>{formatDate(injury.dateOfInjury)}</td>
                                                    <td>{injury.diagnosisTypeName}</td>
                                                    <td>{injury.injurySeverityName}</td>
                                                    <td>{injury.regionAffectedName}</td>
                                                    <td>{injury.mechanismOfInjuryName}</td>
                                                    <td>{injury.injuryManagementApproachName}</td>
                                                    <td>{formatDate(injury.dateOfReturnToSports)}</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </ul>
                        </div>
                        <div className="card dashboard-card court-information">
                            <div className="card-header">
                                <h4>Surgery History</h4>
                            </div>
                            <ul className="appointmentset">
                                <div className="table-responsive table-datatble">
                                    <table className="table datatable">
                                        <thead>
                                            <tr>
                                                <th>Date of Surgery</th>
                                                <th>Category Name</th>
                                                <th>Body Region</th>
                                                <th>Procedure Summary</th>
                                                <th>Complications(if any)</th>
                                                <th>Rehabilitation Duration</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {surgeryInfo.map(surgery => (
                                                <tr key={surgery.injuryProfileId}>
                                                    <td>{formatDate(surgery.dateOfSurgery)}</td>
                                                    <td>{surgery.surgeryCategoryName}</td>
                                                    <td>{surgery.bodyRegionName}</td>
                                                    <td>{surgery.procedureSummary}</td>
                                                    <td>{surgery.complicationsIfAny}</td>
                                                    <td>{surgery.rehabilitationDurationName}</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </ul>
                        </div>
                        <div className="card dashboard-card court-information">
                            <div className="card-header">
                                <h5>Physiological History</h5>
                            </div>
                            <div className="appointment-info double-row">
                                <ul className="appointmentset">
                                    {physiologicalInfo.map((item, index) => (
                                        <li key={index}>
                                            <h6>Name{index + 1}</h6>
                                            <p>{item.name}</p>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        </div>
                    </div>
                </ModalBody>
            </Modal>
        </>
    );
};

export default ActiveAthlete;